import { render, staticRenderFns } from "./TrainingUpdate.vue?vue&type=template&id=538d60eb&scoped=true"
import script from "./TrainingUpdate.vue?vue&type=script&lang=js"
export * from "./TrainingUpdate.vue?vue&type=script&lang=js"
import style0 from "./TrainingUpdate.vue?vue&type=style&index=0&id=538d60eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d60eb",
  null
  
)

export default component.exports